export const OPEN_SIDEBAR = "open_sidebar";
export const CLOSE_SIDEBAR = "close_sidebar";
